import axios from "axios";
import APP_CONFIG_URL_ENV from "../env-config";
import { queryClient } from "../queryClient";

const authApi = axios.create({
  baseURL: APP_CONFIG_URL_ENV.REACT_APP_API_URL, // Replace with your actual environment variable
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor
authApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      // config.headers.Authorization = ` ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
authApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      if (window.location.pathname !== "/login") {
        queryClient.clear();
        localStorage.clear();
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default authApi;
